var _style, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergyMeter01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.53,13.27H2.47V2.21h11.05V13.27z M2.97,12.77h10.05V2.71H2.97V12.77z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.76,
    y: 7.04,
    className: "st2",
    width: 0.5,
    height: 4.76
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.63,
    y: 9.12,
    className: "st2",
    width: 4.76,
    height: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.63,
    y: 9.18,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -4.3228 8.4234)",
    className: "st2",
    width: 4.76,
    height: 0.5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.77,
    y: 6.93,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -4.2311 8.3968)",
    className: "st2",
    width: 0.5,
    height: 4.76
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.72,
    y: 4.57,
    className: "st2",
    width: 10.55,
    height: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyMeter01);
export default __webpack_public_path__ + "static/media/EnergyMeter-01.5b34094ef604f639a43b9eaadca11016.svg";
export { ForwardRef as ReactComponent };